module.exports = __webpack_public_path__ + "img/bxb.555f9047.png";